// Location Map
var gmap;
// The home marker
var homeMarker;
// clusterer
var markerClusterer;
// Currently displayed locations
var locations;

const mapLoadingScreenRequestText = 'Allow us to use your location and we\'ll find your nearest retailer.';
// Message for the location loading screen
const mapLoadingScreenText = 'Finding your location...';
// Message for not found
const mapLoadingScreenNotFound = 'Location not found. Try please again.';

// Container for marker popups
var infowindow;

// Location isotope grid on locations page
var $locationGrid;

// Map location markers
var markers = [];

var markerIcon = {};
var markerIconSelected = {};
// determine if map is being loaded for the first time.
var isFirstLoad = true;

const mapStyle = [{
  "featureType": "administrative",
  "elementType": "geometry",
  "stylers": [{
    "visibility": "off"
  }]
},
{
  "featureType": "poi",
  "stylers": [{
    "visibility": "off"
  }]
},
{
  "featureType": "road",
  "elementType": "labels.icon",
  "stylers": [{
    "visibility": "off"
  }]
},
{
  "featureType": "transit",
  "stylers": [{
    "visibility": "off"
  }]
}
];

// Elements that fire once dom is ready
jQuery(document).ready(function ($) {


  if ($('#g-map').length) {
    const inputD = $('#location-search-form .search-field')[0];
    // const inputM = $('#location-search-m .search-field')[0];
    const options = {
      // componentRestrictions: { country: "us" },
      // fields: ["address_components", "geometry", "icon", "name", "zipcode"],
      strictBounds: false,
      types: ['(regions)'],
    };
    window.addEventListener("load", (event) => {

      function getLocation() {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(showPosition);
          console.log('this');
        } else {
          // x.innerHTML = "Geolocation is not supported by this browser.";
        }

      }
      function showPosition(position) {
        console.log('show Position');
        let lat = position.coords.latitude;
        let lon = position.coords.longitude;
        var element = document.querySelector(".wf-location-results-container");
        element.classList.add("active-map");
        getLocations(lat, lon, '', true);
      }
      getLocation();
    });
    const autocompleteD = new google.maps.places.Autocomplete(inputD, options);
    autocompleteD.addListener("place_changed", function () {

      const place = autocompleteD.getPlace();
      if (place.geometry) {
        gmap.systemZoomChange = true;
        getLocations(place.geometry.location.lat(), place.geometry.location.lng(), '', true);
      }
    });



    google.maps.event.addListener(gmap, 'dragend', getMarkersInView);
    google.maps.event.addListener(gmap, 'zoom_changed', getMarkersInView);
  }

  $('[data-tap-to-explore]').click(function () {
    $(this).addClass('hide');
    hideLoading();
    showZoomPrompt();
  });

  // If a user ignores suggestions, this will catch and gecode the input
  $('#location-search-form, #location-search-m').submit(function (e) {
    e.preventDefault();
    $(this).find('.search-field').blur();

    var address = $(this).find('.search-field').val();
    var geocoder = new google.maps.Geocoder();

    geocoder.geocode({
      address: address
    }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        gmap.systemZoomChange = true;
        getLocations(results[0].geometry.location.lat(), results[0].geometry.location.lng(), '', true);
      } else {
        $(this).find('.search-field').val('');
      }
    });

  });


  // attempt to geolocate user
  if (!localStorage.getItem('neeses_visitor_nearest_location_id')) {
    geolocateUser();
    console.log('no code');
  } else {
    console.log('code');
    if (gmap) {
      gmap.systemZoomChange = true;
    }
    setLocation(true);
  }


}); // end jQuery ready

function showLoading() {
  console.log('showLoading');
  var $ = jQuery;

  $('[data-tap-to-explore]').addClass('hide');
  $('[data-loading-icon]').removeClass('hide');
  $('[data-map-cover]').removeClass('hide');
  $('[data-search-column-cover]').removeClass('hide');
} // end showLoading

function hideLoading() {
  console.log('hideLoading');
  var $ = jQuery;
  $('[data-map-cover]').addClass('hide');
  $('[data-search-column-cover]').addClass('hide');
} // end hideLoading

function showZoomPrompt() {
  console.log('showZoomPrompt');
  var $ = jQuery;
  $('[data-map-zoom-prompt]').removeClass('hide');
} // end showZoomPrompt

function hideZoomPrompt() {
  console.log('hideZoomPrompt');
  var $ = jQuery;
  $('[data-map-zoom-prompt]').addClass('hide');
} // end hideZoomPrompt

function showEmptyPrompt() {
  console.log('showEmptyPrompt');
  var $ = jQuery;
  $('[data-map-empty-prompt]').removeClass('hide');
} // end showEmptyPrompt

function hideEmptyPrompt() {
  console.log('hideEmptyPrompt');
  var $ = jQuery;
  $('[data-map-empty-prompt]').addClass('hide');
} // end showEmptyPrompt

function getMarkersInView() {
  console.log('getMarkersInView');
  if (!gmap.systemZoomChange) {
    if (gmap.getZoom() >= 7) {

      var bounds = gmap.getBounds();
      var mCenter = bounds.getCenter();
      var neCorner = bounds.getNorthEast();

      var radius = google.maps.geometry.spherical.computeDistanceBetween(mCenter, neCorner);
      radius *= 0.000621371192; // convert meters to miles

      console.log(radius);

      // var polygon = new google.maps.Polygon({
      //     map: gmap,
      //     paths: [mCenter, neCorner],
      //     fillColor: 'red',
      //     fillOpacity: 0.7
      // });

      getLocations(mCenter.lat(), mCenter.lng(), radius);
      hideZoomPrompt();
    } else {
      clearAllMarkers();
      showZoomPrompt();
      hideEmptyPrompt();
    }
  } else {
    gmap.systemZoomChange = false;
  }

} // end getMarkersInView

function setClusters() {
  console.log('setClusters');
  markerClusterer = new MarkerClusterer(gmap, markers, {
    imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
  });

  google.maps.event.addListener(markerClusterer, 'click', function (cluster) {
    gmap.systemZoomChange = true;
  });
}

function getLocations(lat, lng, dist, setBounds = false) {
  console.log('getLocations');
  var $ = jQuery;

  showLoading();

  $.ajax({
    type: 'POST',
    url: ajax_url,
    data: {
      action: 'get_nearby_locations',
      lat: lat,
      lng: lng,
      distance: dist
    },
    success: function (response) {
      // console.log(response);
      var data = JSON.parse(response);
      if (data.status == "success") {
        hideEmptyPrompt();
        setLocationGrid(data.data);
        if (setBounds) {
          fitToMarkerBounds();
          $('.results-container').animate({
            scrollTop: 0
          }, 500);
        }
      } else {
        showEmptyPrompt();
        clearAllMarkers();
      }
      hideLoading();
    },
    error: function () {

    }
  });
} // end getLocations

function setLocationGrid(data) {
  console.log('setLocationGrid');
  var $ = jQuery;

  clearAllMarkers();

  if (data.length > 0) {
    $('[data-search-cover]').addClass('hide');
    $('[data-nearby-heading]').removeClass('hide');
    hideZoomPrompt();
  }

  for (var i = 0; i < data.length; i++) {
    var locationItemClone = $('#location-grid [data-location-template]').clone();
    console.log('locationItem:' + locationItemClone);
    locationItemClone.attr('id', 'location-' + data[i]['ID']);

    locationItemClone.find('.location-title h6').html(data[i]['store_name'] + '<br /> ');

    if (localStorage.getItem('neeses_visitor_nearest_location_id') == data[i]['ID']) {
      locationItemClone.find('.set-location-button').addClass('current-location');
    }

    locationItemClone.find('.location-address').html(data[i]['street_address'] + '<br /> ' + data[i]['city'].replace(/,/g, '') + ', ' + data[i]['state'] + ' ' + data[i]['zip']);

    locationItemClone.find('.location-distance [data-miles-away]').text(parseFloat(data[i]['distance']).toFixed(1));
    locationItemClone.find('.location-distance').removeClass('invisible');

    locationItemClone.find('.wf-where-to-buy-btn-link').attr('href', 'https://www.google.com/maps/dir//' + data[i]['lat'] + ',' + data[i]['lng']);


    locationItemClone.removeAttr('data-location-template');
    locationItemClone.removeClass('hide');

    $('#location-grid').append(locationItemClone);

    markers.push(new google.maps.Marker({
      position: new google.maps.LatLng(parseFloat(data[i]['lat']), parseFloat(data[i]['lng'])),
      icon: markerIcon,
      map: gmap
    }));

    var markerIndex = i;
    infowindow = new google.maps.InfoWindow();

    locations = data;

    google.maps.event.addListener(markers[markerIndex], 'click', (function (marker, i) {
      return function () {
        // console.log(i);
        infowindow.setContent('<div class="title">' +
          '<strong>' + locations[i]['store_name'] + '</strong>' +
          '</div>' +
          '<div class="address">' + locations[i]['street_address'] + '<br /> ' + (locations[i]['city']).replace(/,/g, '') + ', ' + locations[i]['state'] + ' ' + locations[i]['zip'] + '</div>');
        infowindow.open(gmap, marker);

        $('#location-select-' + locations[i]['ID']).click();

        // console.log($('#location-' + locations[i]['ID']));

        $('.results-container').animate({
          scrollTop: $('.results-container').scrollTop() + $('#location-' + locations[i]['ID']).position().top
        }, 500);
      }
    })(markers[markerIndex], markerIndex));
  }

  $('#location-grid input[type="radio"] + label').click(function () {
    var markerIndex = $(this).parent().index() - 1; // account for template
    //
    var marker = new google.maps.Marker({});
    new google.maps.event.trigger(markers[markerIndex], 'click');

    // Zoom in to location
    // gmap.setCenter(markers[markerIndex].position);
    // gmap.setZoom(11);
  });

  if (localStorage.getItem('neeses_visitor_nearest_location_id') && isFirstLoad) {
    $pid = localStorage.getItem('neeses_visitor_nearest_location_id');
    if ($('#location-' + $pid).length) {
      var markerIndex = $('#location-' + $pid).index() - 1; // account for template
      // markers[markerIndex].click();
      var marker = new google.maps.Marker({});
      new google.maps.event.trigger(markers[markerIndex], 'click');
    }
    isFirstLoad = false;
  }

  setClusters();
} // end setLocationGrid

function clearAllMarkers() {
  console.log('clearAllMarkers');
  var $ = jQuery;
  // Set location grid heading
  $('[data-search-cover]').removeClass('hide');
  $('[data-nearby-heading]').addClass('hide');
  // clear out location items
  $('#location-grid .location-item:not(.hide)').each(function () {
    $(this).remove();
  });
  // Clear all map markers
  for (var m = 0; m < markers.length; m++) {
    markers[m].setMap(null);
  }
  markers = [];
  if (typeof markerClusterer !== 'undefined') {
    markerClusterer.clearMarkers();
  }
} // end clearAllMarkers

function fitToMarkerBounds() {
  console.log('fitToMarkerBounds');
  if (markers.length) {
    var bounds = new google.maps.LatLngBounds();
    for (var i = 0; i < markers.length; i++) {
      bounds.extend(markers[i].position);
    }
    gmap.fitBounds(bounds);
  }

} // end fitToMarkerBounds

// Fires when google maps is ready
function initMap() {
  console.log('initMap');
  var $ = jQuery;

  markerIcon = {
    url: '/wp-content/themes/neeses-sausage/assets/images/marker-active.svg',
    scaledSize: new google.maps.Size(35, 53)
  };
  markerIconSelected = {
    url: '/wp-content/themes/neeses-sausage/assets/images/marker-active.svg',
    scaledSize: new google.maps.Size(35, 53)
  };

  if ($('#g-map').length) {
    gmap = new google.maps.Map(document.getElementById("g-map"), {
      // center: new google.maps.LatLng(-33.92, 151.25),
      // zoom: 8
      mapTypeControl: false,
      fullscreenControl: false,
      streetViewControl: false,
      styles: mapStyle
    });

    // Center on the USA
    gmap.setCenter(new google.maps.LatLng(39.8097343, -98.5556199));
    gmap.setZoom(4);
  }

} // end initMap


function geolocateUser() {
  console.log('geolocateUser');
  var $ = jQuery;
  // console.log('Get Location');
  var geocoder = new google.maps.Geocoder();

  setFindingLocation();

  navigator.geolocation.getCurrentPosition(function (position) {
    var latitude = position.coords.latitude;
    var longitude = position.coords.longitude;

    $.ajax({
      type: 'POST',
      url: ajax_url,
      data: {
        action: 'get_nearby_locations',
        lat: latitude,
        lng: longitude,
        distance: ''
      },
      success: function (response) {
        var data = JSON.parse(response);
        if (data.data.length) {
          // setAsStore(data.data[0]['ID'], data.data[0]['title'], data.data[0]['order_url'], data.data[0]['location_details']);
          //setAsStore(data.data[0]['ID']);
          console.log('set store')
        }
      },
      error: function () {

      }
    });
  },
    function (error) {
      if (!localStorage.getItem('neeses_visitor_nearest_location_id')) {
        unsetFindingLocation();
        // setLoadingCoverScreen(mapLoadingScreenRequestText, true);
      }
      // console.log('denied: ', error);
      // $('#wf-store-locator-get-location').prop('disabled', true);
      // setAlertMessage('Error: ' + error.message);
    },
    function (options) {
      // console.log('options: ', options);
    }
  );

} // end geolocateUser

function setAsStore(locationID, title = '', order_url = '', permalink = '', store_num = '', location_groups = '') {
  console.log('setAsStore');
  var $ = jQuery;
  unsetLocationLS();

  // Unset all location buttons
  $('.set-location-button').each(function () {
    $(this).removeClass('current-location')
  });

  localStorage.setItem('neeses_visitor_nearest_location_id', locationID);

  if (!title.length || !order_url.length || !permalink.length) {
    $.ajax({
      type: 'POST',
      url: ajax_url,
      data: {
        action: 'get_location',
        location_id: locationID
      },
      success: function (response) {
        var data = JSON.parse(response);
        if (data.data) {
          localStorage.setItem('neeses_visitor_nearest_location', data.data['title']);
          localStorage.setItem('neeses_visitor_order_url', data.data['order_url']);
          localStorage.setItem('neeses_visitor_location_details', data.data['permalink']);
          localStorage.setItem('neeses_visitor_location_store', data.data['store_num']);
          localStorage.setItem('neeses_visitor_location_groups', data.data['location_groups']);
          setLocation();
        }
      },
      error: function () {

      }
    });
  } else {
    localStorage.setItem('neeses_visitor_nearest_location', title);
    localStorage.setItem('neeses_visitor_order_url', order_url);
    localStorage.setItem('neeses_visitor_location_details', permalink);
    localStorage.setItem('neeses_visitor_location_store', store_num);
    localStorage.setItem('neeses_visitor_location_groups', location_groups);
    setLocation();
  }
} // end setAsStore

function unsetLocationLS() {
  console.log('unsetLocationLS');
  localStorage.removeItem('neeses_visitor_nearest_location_id');
  localStorage.removeItem('neeses_visitor_nearest_location');
  localStorage.removeItem('neeses_visitor_order_url');
  localStorage.removeItem('neeses_visitor_delivery_url');
  localStorage.removeItem('neeses_visitor_delivery_off');
  localStorage.removeItem('neeses_visitor_location_details');
  localStorage.removeItem('neeses_visitor_location_store');
  localStorage.removeItem('neeses_visitor_location_groups');
}

function setLocation(reload = false) {
  console.log('setLocation');
  var $ = jQuery;

  // Set Location Button to reflect current store.
  $('[data-find-location-button]').each(function () {

    $(this).find('[data-find-location]').addClass('hide');
    $(this).find('[data-find-location-show]').addClass('hide');
    $(this).find('[data-find-location-finding]').removeClass('hide');

    $(this).find('[data-find-location-name] strong').text(localStorage.getItem('neeses_visitor_nearest_location'));
    $(this).find('[data-find-location-finding]').addClass('hide');
    $(this).find('[data-find-location-show]').removeClass('hide');

    $(this).removeClass('hide');
  });

  // Set location buttons
  $('.set-location-button[data-location-id="' + localStorage.getItem('neeses_visitor_nearest_location_id') + '"]').each(function () {
    $(this).addClass('current-location');
  });

  // Set Order Buttons
  if (localStorage.getItem('neeses_visitor_order_url')) {
    $('[data-order-link]').each(function () {
      $(this).attr('href', localStorage.getItem('neeses_visitor_order_url'));
    });
  }

  // Set map
  if ($('#g-map').length && reload) {
    showLoading();
    $.ajax({
      type: 'POST',
      url: ajax_url,
      data: {
        action: 'get_location',
        location_id: localStorage.getItem('neeses_visitor_nearest_location_id')
      },
      success: function (response) {
        var data = JSON.parse(response);
        if (data.data) {
          getLocations(data.data['lat'], data.data['lng'], '', true);
        }
      },
      error: function () {

      }
    });

  }


}

function setFindingLocation() {
  console.log('setFindingLocation');
  var $ = jQuery;

  $('[data-please-set-location]').addClass('hide');
  $('[data-finding-your-location]').removeClass('hide');

  $('[data-find-location-button]').each(function () {
    $(this).find('[data-find-location]').addClass('hide');
    $(this).find('[data-find-location-show]').addClass('hide');
    $(this).find('[data-find-location-finding]').removeClass('hide');
    $(this).removeClass('hide');
  });

  $('[data-show-for-no-location]').each(function () {
    $(this).removeClass('hide');
  });
} // end setFindingLocation

function unsetFindingLocation() {
  console.log('unsetFindingLocation');
  // console.log('unset finding location');
  var $ = jQuery;
  $('[data-find-location-button]').each(function () {
    $(this).find('[data-find-location-show]').addClass('hide');
    $(this).find('[data-find-location-finding]').addClass('hide');
    $(this).find('[data-find-location]').removeClass('hide');
    $(this).removeClass('hide');
  });

  if (!localStorage.getItem('neeses_visitor_location_store')) {
    // Hide all location dependent elements
    $('[data-show-for-stores], [data-hide-for-stores]').each(function () {
      $(this).addClass('hide');
    });
    // console.log('no location');
    $('[data-please-set-location]').removeClass('hide');
    $('[data-finding-your-location]').addClass('hide');
  }
} // end unsetFindingLocation



